import React, {forwardRef, useState} from "react";
import {AutoComplete, Button, ButtonToolbar, DatePicker, Form, Modal} from 'rsuite';
import {addNewUserCert} from "../../../service/certService";
import {certModel} from "../../form/models";

const earnedDateInstance = forwardRef((props, ref) =>
    <DatePicker {...props} format="yyyy-MM" oneTap ranges={[]} style={{width: 200}} ref={ref}/>
);

const AddCertModal = (props) => {
    const { open, handleClose, certs, userId } = props;

    const [localState, setLocalState] = useState({userId});

    const submitCertAdd = (isFormValid) => {
        if(!isFormValid) return;
        addNewUserCert(localState).then((response) => {
            handleClose(response);
        });
    };

    // rsuite does not have an onSubmit, we must handle state changes per controlled field
    const handleFormChange = (event) => {
        setLocalState({...localState, ...event});
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            backdrop="static"
            size="md"
        >
            <Modal.Header>
                <Modal.Title>Add Certification</Modal.Title>
            </Modal.Header>
            <Form
                layout="horizontal"
                model={certModel}
                onChange={handleFormChange}
                onSubmit={submitCertAdd}
            >
                <Form.Group>
                    <Form.ControlLabel>Certification Name</Form.ControlLabel>
                    <Form.Control name="certName"
                                  accepter={AutoComplete}
                                  data={certs}
                                  style={{width: 500}}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>Date Earned</Form.ControlLabel>
                    <Form.Control name="dateEarned"  accepter={earnedDateInstance}/>
                </Form.Group>
                <Form.Group>
                    <ButtonToolbar>
                        <Button type="submit" appearance="primary">
                            Ok
                        </Button>
                        <Button onClick={handleClose} appearance="default">
                            Cancel
                        </Button>
                    </ButtonToolbar>
                </Form.Group>
            </Form>
        </Modal>
    );
}

export default AddCertModal;